// project-imports
import { ThemeMode } from '@/config';

// types
import { PaletteThemeProps } from '@/types/base/theme';

// ==============================|| PRESET THEME - DEFAULT ||============================== //

export default function Default(mode: ThemeMode): PaletteThemeProps {
  const contrastText = '#fff';

  let primaryColors = [
    '#EBF1FF',
    '#DBE7FF',
    '#B3CBFF',
    '#8FB2FF',
    '#6B9AFF',
    '#4680FF',
    '#0554FF',
    '#003DC2',
    '#002880',
    '#001542',
    '#000A1F'
  ];
  let secondaryColors = [
    '#FFFDF0',
    '#FFFCE0',
    '#FFF8BD',
    '#FFF59E',
    '#FFF27A',
    '#FFEF5C',
    '#FFEB3B',
    '#EBD300',
    '#9E8E00',
    '#4D4500',
    '#292500'
  ];
  let errorColors = ['#FEEDEC', '#F69088', '#F04438', '#DA1E10', '#6D0F08'];
  let warningColors = ['#FEF4E6', '#FABC6B', '#F9A639', '#C67306', '#633903'];
  let infoColors = ['#EDF6FD', '#8AC5F0', '#3D9FE6', '#1B84D0', '#0D4268'];
  let successColors = ['#E7F9F3', '#5CEAA8', '#17B26A', '#139156', '#09482B'];
  let neutralColors = [
    '#F6F7F8',
    '#EBEDEF',
    '#D7DBE0',
    '#C6CCD2',
    '#B2BAC2',
    '#9EA9B3',
    '#8A97A3',
    '#63717E',
    '#434D56',
    '#22262B',
    '#101214'
  ];
  let disabledColors = ['#FCFCFD', '#EAEDF0', '#676a6d', '#A6B3BF', '#4B5968']; // '#DBE0E5'

  if (mode === ThemeMode.DARK) {
    primaryColors = [
      '#000A1F',
      '#001542',
      '#002880',
      '#003DC2',
      '#0554FF',
      '#4680FF',
      '#6B9AFF',
      '#8FB2FF',
      '#B3CBFF',
      '#DBE7FF',
      '#EBF1FF'
    ];
    secondaryColors = [
      '#292500',
      '#4D4500',
      '#9E8E00',
      '#EBD300',
      '#FFEB3B',
      '#FFEF5C',
      '#FFF27A',
      '#FFF59E',
      '#FFF8BD',
      '#FFFCE0',
      '#FFFDF0'
    ];

    errorColors = ['#6D0F08', '#DA1E10', '#F04438', '#F69088', '#FEEDEC'];
    warningColors = ['#633903', '#C67306', '#F9A639', '#FABC6B', '#FEF4E6'];
    infoColors = ['#0D4268', '#1B84D0', '#3D9FE6', '#8AC5F0', '#EDF6FD'];
    successColors = ['#09482B', '#139156', '#17B26A', '#5CEAA8', '#E7F9F3'];
    neutralColors = [
      '#101214',
      '#22262B',
      '#434D56',
      '#63717E',
      '#8A97A3',
      '#9EA9B3',
      '#B2BAC2',
      '#C6CCD2',
      '#D7DBE0',
      '#EBEDEF',
      '#F6F7F8'
    ];
    disabledColors = ['#4B5968', '#A6B3BF', '#DBE0E5', '#EAEDF0', '#FCFCFD'];
  }

  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      950: primaryColors[10],
      contrastText
    },

    neutral: {
      lighter: neutralColors[0],
      100: neutralColors[1],
      200: neutralColors[2],
      light: neutralColors[3],
      400: neutralColors[4],
      500: neutralColors[5]!,
      main: neutralColors[6],
      dark: neutralColors[7],
      800: neutralColors[8],
      darker: neutralColors[9],
      950: neutralColors[10],
      contrastText
    },

    secondary: {
      lighter: secondaryColors[0],
      100: secondaryColors[1],
      200: secondaryColors[2],
      light: secondaryColors[3],
      400: secondaryColors[4],
      500: secondaryColors[5]!,
      main: secondaryColors[6],
      dark: secondaryColors[7],
      800: secondaryColors[8],
      darker: secondaryColors[9],
      950: secondaryColors[10],
      contrastText
    },
    error: {
      lighter: errorColors[0],
      light: errorColors[1],
      main: errorColors[2],
      dark: errorColors[3],
      darker: errorColors[4],
      contrastText
    },
    warning: {
      lighter: warningColors[0],
      light: warningColors[1],
      main: warningColors[2],
      dark: warningColors[3],
      darker: warningColors[4],
      contrastText
    },
    info: {
      lighter: infoColors[0],
      light: infoColors[1],
      main: infoColors[2],
      dark: infoColors[3],
      darker: infoColors[4],
      contrastText
    },
    success: {
      lighter: successColors[0],
      light: successColors[1],
      main: successColors[2],
      dark: successColors[3],
      darker: successColors[4],
      contrastText
    },
    disabled: {
      lighter: disabledColors[0],
      light: disabledColors[1],
      main: disabledColors[2],
      dark: disabledColors[3],
      darker: disabledColors[4],
      contrastText
    }
  };
}
